/** Plugin name — also the key the service-level config is stored under. */
export const EMAIL_AUTH_PLUGIN_NAME = 'auth-email';

/** Auth-provider key surfaced to the host (`provider_accounts`, `/auth/me`). */
export const EMAIL_AUTH_PROVIDER = 'email';

/** Service-config field key: whether self-service registration is allowed. */
export const REGISTRATION_ENABLED_KEY = 'registrationEnabled';
